import { render, staticRenderFns } from "./SuperAdminCollegeAdmins.vue?vue&type=template&id=dc59ff3a&"
import script from "./SuperAdminCollegeAdmins.vue?vue&type=script&lang=js&"
export * from "./SuperAdminCollegeAdmins.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminCollegeAdmins.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports